module.exports = __webpack_public_path__ + "img/logo_swissuniversities.f09ffdfb.svg";